<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">{{title}}</v-card-title>

    <v-card-text>

        <v-row>
        
            <v-col>
                <v-text-field
                    label="Start"
                    v-model="start_text"
                    v-on:input="onChange"
                    autocomplete="off"
                />
            </v-col>

            <v-col>
                <v-text-field
                    label="End"
                    v-model="end_text"
                    v-on:input="onChange"
                    autocomplete="off"
                />
            </v-col>

        </v-row>

        <span v-show="ok_value != null">
            Interval: {{ok_value}}
        </span>

        <span v-show="ok_value == null">
            Interval: Not valid.
        </span>

       
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

         <v-btn
            color="gray darken-1"
            text
            v-on:click="onAllDay"
        >
        All Day
        </v-btn>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary"
            text
            :disabled="!isValid()"
            @click="onOk"
        >
        Ok
        </v-btn>

    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {
    props: {
        title: {
            type: String,
            default: function () { return 'Edit Time Interval'; }
        },
    },

    data() {
        return {
            dialog: false,
            start_text: null,
            end_text: null,
            ok_value: null,
         }
    },

    methods: {
        showDialog(value) 
        {
            if ( value == null ) value = "9:00 AM - 5:00 PM";
            this.ok_value = null;

            this.$rc.showSpinner();
            
            this.$rc.parseInterval(
                value,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.start_text = data.start_pretty_print;
                    this.end_text = data.end_pretty_print;

                    this.dialog = true;   
                    this.ok_value = data.interval; 
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to parse interval.');
                },
            );
        },
        
        onAllDay()
        {
            this.dialog = false;
            this.$emit('ok','All Day');
        },

        isValid()
        {
            return this.ok_value != null;
        },

        onChange()
        {
            this.$rc.rest(
                'POST: /api/v1/time/normalize-interval',
            
                {
                    'start' : this.start_text,
                    'end' : this.end_text
                },
            
                (data) => 
                {
                    if ( data.is_valid )
                    {
                        this.ok_value = data.interval;
                    }
                    else
                    {
                        this.ok_value = null;
                    }
                },
            
                () => {
                },
            );
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok',this.ok_value);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>